/**
 * @generated SignedSource<<abb4a03705da2b10e2775490bda15f0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayVariant_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_item" | "ItemPrice_item" | "useItemPriceData_item" | "useShowIncludedLabelsInline_item">;
  readonly " $fragmentType": "PriceDisplayVariant_item";
};
export type PriceDisplayVariant_item$key = {
  readonly " $data"?: PriceDisplayVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplayVariant_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IncludedLabels_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowIncludedLabelsInline_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1c6344bf6e6e9df6904adb93ba4b67c2";

export default node;
